import type React from 'react';
import type { Button as ButtonType } from '../../../types/ChatWindow';
import type { MessageScheme } from '../../../types/configs';
import CarouselButton from './CarouselButton';

type IProps = {
  buttons: ButtonType[];
  onClick: (...args: any[]) => void;
  scheme: MessageScheme;
};

const CarouselButtonList: React.FC<IProps> = ({ buttons, onClick, scheme }) => {
  return (
    <>
      {buttons
        ? buttons.map((button) => {
            return (
              <CarouselButton
                key={button.payload + button.title}
                scheme={scheme}
                button={button}
                onClick={onClick}
              />
            );
          })
        : null}
    </>
  );
};

export default CarouselButtonList;
